/**
 * Page Designer RTF editing session.
 * Maps card ids to in-canvas editors so the top toolbar can format
 * only the selected card. No patient/encounter/placeholder state.
 */

const editors = new Map();

export function registerRtfEditor(cardId, api) {
  if (!cardId || !api) return () => {};
  editors.set(cardId, api);
  return () => {
    if (editors.get(cardId) === api) editors.delete(cardId);
  };
}

export function runRtfCommand(cardId, command, arg) {
  const api = cardId ? editors.get(cardId) : null;
  if (!api || typeof api.run !== "function") return false;
  api.run(command, arg);
  return true;
}

export function hasRtfEditor(cardId) {
  return Boolean(cardId && editors.has(cardId));
}
